import { THEME_COLOR } from "../../../constants";

// Days of week configuration
export const DAYS_OF_WEEK = [
  { label: "Monday", value: "monday" },
  { label: "Tuesday", value: "tuesday" },
  { label: "Wednesday", value: "wednesday" },
  { label: "Thursday", value: "thursday" },
  { label: "Friday", value: "friday" },
  { label: "Saturday", value: "saturday" },
  { label: "Sunday", value: "sunday" },
];

// TimePicker slot props configuration
export const TIME_PICKER_SLOT_PROPS = {
  actionBar: {
    sx: {
      "& .MuiButton-root": {
        color: "#000",
        fontFamily: "GilroySemiBold",
      },
    },
  },
  digitalClockSectionItem: {
    sx: {
      fontSize: 13,
      fontFamily: "GilroySemiBold",
      "&.Mui-selected": {
        backgroundColor: `${THEME_COLOR}`,
        color: "#000",
        "&:hover": {
          backgroundColor: `${THEME_COLOR}`,
          color: "#000",
        },
      },
    },
  },
  textField: {
    variant: "standard",
    InputLabelProps: {
      style: { fontFamily: "GilroyRegular", color: "#000" },
      shrink: true,
    },
    inputProps: {
      readOnly: true,
      sx: {
        height: 30,
        fontSize: 13,
        fontFamily: "GilroySemiBold",
      },
    },
    sx: {
      "& .MuiInputBase-root": {
        borderBottom: "1px solid #0000006b",
        "&:before, :after, :hover:not(.Mui-disabled):before": {
          borderBottom: "1px solid #0000006b",
        },
        "&.Mui-error:after": {
          borderBottom: "1px solid #0000006b",
        },
      },
      svg: { color: "#000", fontSize: 18 },
      "& .MuiButtonBase-root": {
        width: 35,
        height: 35,
      },
    },
  },
};

// Default form values
export const DEFAULT_BASIC_SETTINGS = {
  isEnabled: false,
  type: "classic",
};

export const DEFAULT_RESTAURANT_SETTINGS = {
  deposit: [{
    priceConfiguration: [
      { minCover: 1, maxCover: 10, price: 100 },
      { minCover: 11, maxCover: 20, price: 150 },
      { minCover: 21, maxCover: 50, price: 250 },
    ],
  }],
  restaurantEmails: [""],
  restaurantPhones: [""],
  maxCoverPerBooking: 20,
  standardSeatingTimeMinutes: 120,
  bookingIntervalMinutes: 30,
  termsLink: "",
  bookingAvailability: DAYS_OF_WEEK.map(day => ({
    dayOfWeek: day.value,
    openingTime: "09:00",
    closingTime: "22:00",
    totalCovers: 0,
    availableCovers: 0,
  })),
};

// Booking types
export const BOOKING_TYPES = {
  CLASSIC: "classic",
  SUPREME: "supreme",
};


